<template>
    <div>
        <Topbar ref="topbar" />
        <div class="m-auto news-word">
            <Breadcrumb ref="breadcrumb" :title="'操作手册'" />
            <div v-loading="loading" class="guide-body">
                <template v-if="guide && guide.fileUrl">
                    <!-- 图片：直接预览 -->
                    <el-image v-if="isImage" style="width: 100%; height: auto" :src="guide.fileUrl" fit="contain"></el-image>
                    <!-- 非图片（含 PDF）：文件读取接口固定返回 Content-Disposition: attachment，
                         内嵌预览只会是一片空白，这里改为下载后查看 -->
                    <div v-else class="guide-tip">
                        <p>该操作手册为 {{ fileExt ? fileExt.toUpperCase() : '' }} 格式，请下载后查看。</p>
                        <el-button type="primary" size="small" @click="download">下载并查看</el-button>
                    </div>
                </template>
                <el-empty v-else-if="!loading" description="当前考试暂未上传操作手册" />
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb/index.vue";
import * as ExamApi from "@/api/exam/index";

export default {
    name: "WordView",
    components: {
        Breadcrumb,
    },
    data() {
        return {
            loading: false,
            guide: null,
        };
    },
    computed: {
        // 文件后缀（用于判断展示方式）
        fileExt() {
            const name = (this.guide && (this.guide.fileName || this.guide.fileUrl)) || "";
            const idx = name.lastIndexOf(".");
            return idx > -1 ? name.substring(idx + 1).toLowerCase() : "";
        },
        isImage() {
            return ["jpg", "jpeg", "png", "gif", "bmp", "webp"].includes(this.fileExt);
        },
    },
    created() {
        this.loadGuide();
    },
    methods: {
        // 按考试ID加载操作指南（与后台维护的指南一致）
        async loadGuide() {
            const examId = this.$route.query.examId;
            if (!examId) return;
            this.loading = true;
            try {
                const res = await ExamApi.getGuide({ examId });
                this.guide = res && res.fileUrl ? res : null;
            } catch (e) {
                this.guide = null;
            } finally {
                this.loading = false;
            }
        },
        download() {
            if (this.guide && this.guide.fileUrl) {
                window.open(this.guide.fileUrl);
            }
        },
    },
};
</script>

<style scoped lang="scss">
.news-word {
    width: 74%;
    padding-top: 20px;
}

.guide-body {
    min-height: 300px;
}

.guide-name {
    margin: 12px 0;
    font-size: 16px;
    font-weight: bold;
    color: #303133;
}

.guide-tip {
    padding: 40px 0;
    text-align: center;
    color: #606266;
}

@media screen and (max-width: 1024px) {
    .news-word {
        width: 80%;
    }
}

@media screen and (max-width: 768px) {
    .news-word {
        width: 90%;
    }

}
</style>
